// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"Spinner_spinnerWrapper__MUVnK","spinner":"Spinner_spinner__Z6H3Z"};